import { render, staticRenderFns } from "./ticket-item.vue?vue&type=template&id=732d0dea&scoped=true&"
import script from "./ticket-item.vue?vue&type=script&lang=js&"
export * from "./ticket-item.vue?vue&type=script&lang=js&"
import style0 from "./ticket-item.vue?vue&type=style&index=0&id=732d0dea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732d0dea",
  null
  
)

export default component.exports